export const match = (param: string) => {
	const endsWithPublicId = /[A-Za-z0-9]{11}$/
	return endsWithPublicId.test(param)
}
